module.exports = __webpack_public_path__ + "img/c_05.8c196275.jpg";